// !  正则验证

// 应用英文名正则, 数据库名字正则, 用户账号 允许英文,数字,中划线,下划线
export const letterNumberDashUnderlinePattern = /^[a-zA-Z0-9-_]+$/

// QQ正则
export const qqPattern = /^[1-9][0-9]{4,10}$/

// TODO 总结分组捕获
export const packageNamePattern = /^([a-zA-Z]+[.][a-zA-Z]+)*$/

export const contextPattern = /^\/[a-zA-Z-]*$/

// artifactId正则 数字,字母,中划线
export const numberLetterDashPattern = /^[a-zA-Z0-9-]+$/

// 允许英文,数字,下划线的正则
export const letterNumberUnderlinePattern = /^\w+$/

// 版本校验
export const versionPattern = /^(?:(\d+)\.)?(?:(\d+)\.)?(\*|\d+)$/

// 密码校验 6-16位数 仅为字母和数字
export const pswPattern = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/

// 仅为小写字母和中划线
export const letterDashPattern = /^[a-z-]+$/

// 应用名 工程名校验
export const namePattern = /^[a-z0-9][a-z0-9_-]{0,18}[a-z0-9]$/

// 手机号(mobile phone)中国(宽松), 只要是13,14,15,16,17,18,19开头即可
export const phonePattern = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/

// 2021年1月19日14:52:55,产品提出由于要兼容国外的手机号,改为数字限制20位以内
// 2021年4月12日11:47:59,产品提出其实是15个就行了
export const phoneNumberPattern = /(^[0-9]{1,15}$)/

// 座机(tel phone)电话(国内),如: 0341-86091234, 或者86091234, 前面的区号可以不带,也可以带
// export const fixedPhonePattern = /^\d{3}-\d{8}|\d{4}-\d{7,8}$/;
export const fixedPhonePattern = /^(\d{3,4}-)?\d{7,8}$/

// 金额校验(格式可以为浮点数)
export const amountPattern = /(^[1-9]([0-9]+)?(\.[0-9]{1,3})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/

// 数字校验
export const numberPattern = /^[0-9]+$/

// 中文字符校验
export const chineseCharPattern = /[\u4E00-\u9FA5]/gm

// 邮箱校验
export const emailPattern =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

// 身份证校验
export const idCardPattern = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0\d|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/

// 邮编校验
export const zipCodePattern = /^[1-9]\d{5}(?!\d)$/

// 账号校验 以字母、数字开头,长度只能在3-20个字符之间,可以包含数字和符号"."、"_"、"@"'
export const accountPattern = /[a-zA-Z\d][a-zA-Z\d._@]{1,19}[a-zA-Z\d]/

// 统一社会信用代码
export const uniformSocialCreditCodePattern = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/

// 网址
export const hyperlinkPattern = /^(((ht|f)tps?):\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/
/**
 * 未验证
 */
